import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { TherapistClientApiService } from '@therapist/shared/services/api/therapist-client-api.service';
import { catchError, first, map, Observable, of, switchMap, timer } from 'rxjs';
import { inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SsnAlreadyInUseValidator implements AsyncValidator {

  readonly #clientApiService = inject(TherapistClientApiService);

  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    const value: string = control.value?.trim() || '';
    if (!value || !this.isValidString(value)) {
      return of(null);
    }

    // wait 300ms after the last keystroke, skip duplicates
    return timer(300).pipe(
      switchMap(() => this.#clientApiService.isSvNrValid(value)),
      map(isValid => (isValid ? null : { alreadyInUse: true })),
      catchError(() => of(null)),
      first()
    );
  }

  private isValidString(str: string): boolean {
    return str.length === 4;
  }
}
